var React = require('react');

function HeaderDefsInline (props) {
    return React.createElement("svg",props,React.createElement("defs",null,[React.createElement("linearGradient",{"id":"header-pattern-a","x1":"50%","x2":"50%","y1":"35.909%","y2":"183.09%","key":0},[React.createElement("stop",{"offset":"0%","stopColor":"#F4F4F4","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#CCCCCF","key":1})]),React.createElement("rect",{"id":"header-pattern-b","width":"168","height":"166","x":"0","y":"0","key":1})]));
}

HeaderDefsInline.defaultProps = {};

module.exports = HeaderDefsInline;

HeaderDefsInline.default = HeaderDefsInline;
